import React from 'react';
import { ConnectedAccounts } from '../components/account/ConnectedAccounts';
import { useAuth } from '../auth';

export default function Connections() {
  const { user } = useAuth();
  return <div className="connections-page" data-testid="connections-page"><ConnectedAccounts key={user.id} /></div>;
}